module.exports = __webpack_public_path__ + "static/Kollektif-Bold-381e8d982e0d872eadc7a13356b1afa2.woff";